/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Days_Title_FixedInputs */

const en_us2_profile_editors_days_title_fixed = /** @type {(inputs: Profile_Editors_Days_Title_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which days?`)
};

const pt_br2_profile_editors_days_title_fixed = /** @type {(inputs: Profile_Editors_Days_Title_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais dias?`)
};

const es_419_profile_editors_days_title_fixed = /** @type {(inputs: Profile_Editors_Days_Title_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué días?`)
};

const pt_pt2_profile_editors_days_title_fixed = /** @type {(inputs: Profile_Editors_Days_Title_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dias?`)
};

const fr_fr2_profile_editors_days_title_fixed = /** @type {(inputs: Profile_Editors_Days_Title_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels jours ?`)
};

const de_de2_profile_editors_days_title_fixed = /** @type {(inputs: Profile_Editors_Days_Title_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Tage?`)
};

const it_it2_profile_editors_days_title_fixed = /** @type {(inputs: Profile_Editors_Days_Title_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali giorni?`)
};

/**
* | output |
* | --- |
* | "Which days?" |
*
* @param {Profile_Editors_Days_Title_FixedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_days_title_fixed = /** @type {((inputs?: Profile_Editors_Days_Title_FixedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Days_Title_FixedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_days_title_fixed(inputs)
	if (locale === "es-419") return es_419_profile_editors_days_title_fixed(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_days_title_fixed(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_days_title_fixed(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_days_title_fixed(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_days_title_fixed(inputs)
	return en_us2_profile_editors_days_title_fixed(inputs)
});
export { profile_editors_days_title_fixed as "profile-editors.days_title_fixed" }